export default {
	"title": "Нужна поддержка",
	"image": "Скриншоты",
	"email": "Email",
	"name": "Имя",
	"placeholder": "Вы можете описать свои проблемы или поделиться своими идеями с нами здесь",
	"desc": "Ваши отзывы будут рассмотрены как можно быстрее.",
	"submit": "Отправить",
}
